/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/Content/Images/Error"
  
}) {
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 text="There was an error loading the patient's images"
/>
{children}
</React.Fragment>)
}